export const GET_ANOUNCEMENT_SUCCESS = 'GET_ANOUNCEMENT_SUCCESS';
export const GET_ANOUNCEMENT_ERROR = 'GET_ANOUNCEMENT_ERROR';